/**
 * useInfiniteHistoryMessages - Timeline de mensagens do histórico (contato+canal)
 *
 * Pagina GET /conversations/history/:contactId/:channelId/messages — mensagens
 * de TODAS as conversas fechadas do par, sentAt desc (página 1 = mais recentes,
 * próximas páginas = mais antigas). O consumidor reverte pra ordem cronológica,
 * exatamente como o ChatBox faz com useInfiniteMessages.
 */

import { useInfiniteQuery } from '@tanstack/react-query';
import { getConversationHistoryMessages } from '../services/chatService';

export const useInfiniteHistoryMessages = (
  contactId: string | undefined,
  channelId: string | undefined,
  limit: number = 70
) => {
  return useInfiniteQuery({
    queryKey: ['messages', 'history-infinite', contactId, channelId],
    queryFn: async ({ pageParam, signal }) => {
      return getConversationHistoryMessages(
        contactId as string,
        channelId as string,
        { page: pageParam as number, limit },
        signal
      );
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.totalPages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: !!contactId && !!channelId,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });
};
